<ion-header [translucent]="true" [class.rr-chat-header--combat]="isCombatScene()">
  <ion-toolbar [ngClass]="{withChatName: activeChatData()}">
    <ion-back-button text="" style="--padding-start: 0.5rem;--padding-end: 0.5rem;" [defaultHref]="story ? backNavigation.storyHome(story.id()) : '/home'" slot="start"></ion-back-button>
    <re-chat-title [chat]="activeChatData()"></re-chat-title>
    @if(allowSettings()){
    <ion-buttons slot="end">
      <ion-button routerLink="./settings" shape="round" fill="clear"
        [attr.aria-label]="'chat.actions.settings' | translate">
        <ion-icon slot="icon-only" name="cog"></ion-icon>
      </ion-button>

    </ion-buttons>
    }
  </ion-toolbar>
  @if (isCombatScene() && sceneChromeLoader(); as chromeLoader) {
    @if (pluginSceneState(); as sceneState) {
      <ion-toolbar class="rr-chat-combat-toolbar">
        <re-game-system-host [loader]="chromeLoader" [inputs]="{ state: sceneState }" />
      </ion-toolbar>
    }
  }
</ion-header>
<ion-content class="rr-chat-skin" [class.rr-chat-skin--combat]="isCombatScene()">
  <h1 class="re-visually-hidden">{{ activeChatData()?.name }}</h1>
  <re-chat-content #chat [allowBookmark]="allowBookmark()" [allowSaveChapter]="allowChapters()"
    [allowCharacters]="allowCharacters() && !isLoreChat()" [scrollElement]="getScrollContainer | async"
    [isAiChat]="isStoryAiChat()" [isLoreChat]="isLoreChat()"
    [usePrivateMessageLayout]="usePrivateMessageLayout()"
    [showStorySetupWizard]="showStorySetupWizard()"
    [showStartAdventureCta]="showStartAdventureCta()"
    [showSetupWizardOverlay]="showSetupWizardOverlay()"
    [storySetupWizardPhase]="storySetupWizardPhase()"
    [showCreateCharacterCta]="showCreateCharacterCta()"
    [storySettingBrief]="story?.settingBrief() ?? null"
    [savedStorySetupAnswers]="savedStorySetupAnswers()"
    [showWaitingForHost]="showWaitingForHost()"
    [showStoryStartingWait]="showStoryStartingWait()"
    [showSettingRetryCta]="showSettingRetryCta()"
    [currentUserHasCharacter]="currentUserHasCharacter()"
    [storyId]="story?.id() ?? 0"
    [storyCharacters]="storyCharacters()"
    [storyOwnerNames]="storyOwnerNames()"
    [currentUserId]="profile()?.id ?? ''"
    [storySetupSubmitting]="storySetupSubmitting()"
    (quoteMessage)="quoteMessageHandler($event)" (sendSuggestedRoll)="onSendSuggestedRoll($event)"
    (suggestedActionClick)="onSuggestedAction($event)" (sendSuggestedMessage)="onSendSuggestedMessage($event)"
    (showProfile)="showProfile($event)" (showCharacter)="showCharacter($event)" (saveBookmark)="saveBookmark($event)"
    (removeBookmark)="removeBookmark($event)" (saveChapter)="saveBookmark($event, true)"
    (removeChapter)="removeBookmark($event, true)" (invokeMaster)="callMaster()"
    (invokeLore)="callLore()" (showMasterOverlay)="openMasterOverlay()" (storySetupCompleted)="onStorySetupCompleted($event)"
    (startAdventure)="onStartAdventure()"
    (preferencesCommitted)="onPreferencesCommitted($event)"
    (characterReady)="onCharacterReady()"
    (retrySetting)="onRetrySetting()"
    (createCharacter)="openCreateCharacter()"></re-chat-content>
  <ion-fab class="fabScroll" slot="fixed" vertical="bottom" horizontal="end" [ngClass]="{'hidden-fab': hideFab()}">
    <ion-fab-button color="primary" (click)="chatComponent()?.scrollToLast()"
      [attr.aria-label]="'chat.actions.scrollToLatest' | translate">
      <ion-icon name="arrow-down"></ion-icon>
    </ion-fab-button>
  </ion-fab>
  @defer (on idle) {
  <re-modal-editor [(text)]="text" [imageSelected]="imageSelected()" [quotedMessage]="quotedMessage()"
    [quotables]="quotables()" [allowImage]="!isAiStory()" (addImage)="addImage()" (sendMessage)="sendMessage()"
    (removeImage)="removeImage()" (quoteMessageHandler)="quoteMessageHandler(undefined)" />
  }
</ion-content>
@if(backdrop()){
<ion-backdrop tappable (ionBackdropTap)="toggleFab()"></ion-backdrop>
}

@if(masterLoading()){
<button class="master-fab" type="button" (click)="masterOverlayDismissed.set(false)"
  [attr.aria-label]="(isLoreChat() ? 'chat.loreOverlay.showStatus' : 'chat.masterOverlay.showStatus') | translate">
  <span class="master-fab__ring" aria-hidden="true"></span>
  <span class="master-fab__ring master-fab__ring--2" aria-hidden="true"></span>
  <ion-icon [name]="masterOverlayIcon()"></ion-icon>
</button>
}

@if(showMasterOverlay()){
<div class="master-overlay" role="dialog" aria-modal="true" aria-live="polite">
  <div class="master-overlay__card">
    <div class="master-overlay__orb-ring" aria-hidden="true">
      <span class="master-overlay__orb"></span>
      <span class="master-overlay__orb master-overlay__orb--2"></span>
      <span class="master-overlay__orb master-overlay__orb--3"></span>
    </div>
    <div class="master-overlay__icon" aria-hidden="true">
      <ion-icon [name]="masterOverlayIcon()"></ion-icon>
    </div>
    <h2 class="master-overlay__title">{{ masterOverlayTitleKey() | translate }}</h2>
    <p class="master-overlay__body" [innerHTML]="masterOverlayBodyKey() | translate"></p>

    <div class="master-overlay__steps" aria-hidden="true">
      @for (status of overlayStatuses(); track status; let i = $index) {
        <span
          class="master-overlay__step"
          [class.master-overlay__step--active]="i === overlayActiveStatusIndex()"
          [class.master-overlay__step--completed]="i < overlayActiveStatusIndex()"
        ></span>
      }
    </div>

    <button class="master-overlay__dismiss" (click)="dismissMasterOverlay()" type="button">
      {{ (isLoreChat() ? 'chat.loreOverlay.continueQuietly' : 'chat.masterOverlay.continueQuietly') | translate }}
      <span class="master-overlay__dismiss-note">{{ (isLoreChat() ? 'chat.loreOverlay.notInterrupted' : 'chat.masterOverlay.notInterrupted') | translate }}</span>
    </button>
  </div>
</div>
}
@if(!hideChatFooter() && !masterLoading()) {
<ion-footer>
  <div class="ion-toolbar toolbar-container">
    <re-footer-editor [(text)]="text" [allowImpersonate]="allowCharacters() && !isLoreChat()"
      [editorRefreshVersion]="editorRefreshVersion()"
      [allowModalEditor]="allowCharacters() && !isLoreChat()" [allowImage]="!isAiStory() && !isLoreChat()"
      [allowOperation]="allowCharacters() && !isLoreChat()" [imageSelected]="imageSelected()"
      [quotedMessage]="quotedMessage()" [quotables]="quotables()" (addImage)="addImage()" (sendMessage)="sendMessage()"
      (removeImage)="removeImage()" (quoteMessageHandler)="quoteMessageHandler(undefined)" (toggleFab)="toggleFab()"
      (openBackdrop)="openBackdrop()" (openModal)="openModal()" (invokeMaster)="callMaster()"
      (invokeLore)="callLore()" (showMasterOverlay)="openMasterOverlay()" [masterBusy]="masterBusy()" [showMaster]="isStoryAiChat()"
      [writePlaceholder]="chatWritePlaceholder()" [showLore]="isLoreChat()"></re-footer-editor>
  </div>
</ion-footer>
}
